<template>
    <div>
        <card-header :title="parentId ? 'New Subcategory' : 'New Category'" icon="fa-plus"/>

        <card-body>
            <category-form :category="category" :is-subcategory="!!parentId"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!category.title"
                        :loading="saving"
                    >
                        <i class="fas fa-plus mr-2"></i>Create Category
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
import CardHeader from "@/TIER/components/CardHeader";
import CardBody from "@/TIER/components/CardBody";
import CardFooter from "@/TIER/components/CardFooter";
import CategoryForm from "./CategoryForm";

import {client as http} from "@/http_client";

export default {
    components: {
        CardHeader,
        CardBody,
        CardFooter,
        CategoryForm
    },
    props: ['card', 'certificationId', 'parentId'],
    data() {
        return {
            category: {
                title: '',
                description: '',
                sort: 0
            },
            saving: false
        };
    },
    methods: {
        submit: function() {
            this.saving = true;

            const data = {
                certification_id: parseInt(this.certificationId),
                parent_id: this.parentId ? parseInt(this.parentId) : null,
                title: this.category.title,
                description: this.category.description || null,
                sort: this.category.sort || 0
            };

            http.post('course-categories/', data).then(response => {
                this.$reloadCard('course-categories');
                this.$closeCard(this.card);
            }).catch(err => {
                console.log(err);
                this.saving = false;
                this.$buefy.toast.open({
                    message: 'Failed to create category',
                    type: 'is-danger'
                });
            });
        }
    }
};
</script>
